
import {
  GET_USERS,
  GET_REPORT_USERS,
  GET_ADMIN_USERS,
  USER_PROFILE,
  SUSPEND_ACCOUNT,
  UPDATE_PROFILE,
  ADD_USER,
  REVOKE_ACCOUNT,
  GET_USERS_LOCATIONS,
  GET_FOLLOWERS,
  GET_FOLLOWING,
  GET_DELETED_USERS,
  CHANGE_APP_PASSWORD,
  UPDATE_AUTO_FOLLOW,
  CHANGE_ADVERTISE_STATUS
} from '../lib/constants/api-urls';
import Api from "../lib/api-call";
import { changeParamsToQuery } from './commonFn';
export class UserService {

  static instance;


  static getInstance() {
    if (!UserService.instance) {
      UserService.instance = new UserService();
    }
    return UserService.instance;
  }


  fetchUsersList = async (params) => {
    let newsResponse = await Api.get(`${GET_USERS.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }

  fetchReportUsers = async (params) => {
    let newsResponse = await Api.get(`${GET_REPORT_USERS.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }

  fetchAdminUsersList = async (params) => {
    let newsResponse = await Api.get(`${GET_ADMIN_USERS.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }

  getUserProfile = async (params) => {
    let newsResponse = await Api.get(`${USER_PROFILE.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }

  suspendAccount = async (params) => {
    let newsResponse = await Api.post((params.revoke) ? REVOKE_ACCOUNT.URL : SUSPEND_ACCOUNT.URL, params);
    return newsResponse;
  }

  updateProfile = async (params) => {
    let newsResponse = await Api.put(UPDATE_PROFILE.URL, params);
    return newsResponse;
  }

  addUser = async (params) => {
    let newsResponse = await Api.post(ADD_USER.URL, params);
    return newsResponse;
  }

  fetchUsersLocations = async (params) => {
    let newsResponse = await Api.get(`${GET_USERS_LOCATIONS.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }

  fetchFollowers = async (params) => {
    let newsResponse = await Api.get(`${GET_FOLLOWERS.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }

  fetchFollowing = async (params) => {
    let newsResponse = await Api.get(`${GET_FOLLOWING.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }

  fetchDeletedUsers = async (params) => {
    let newsResponse = await Api.get(`${GET_DELETED_USERS.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }

  changeAppPassword = async (params) => {
    let newsResponse = await Api.patch(`${CHANGE_APP_PASSWORD.URL}`, params);
    return newsResponse;
  }

  updateAutoFollow = async (params) => {
    let newsResponse = await Api.post(`${UPDATE_AUTO_FOLLOW.URL}`, params);
    return newsResponse;
  }

  changeAdvertiseStatus = async (params) => {
    let newsResponse = await Api.patch(`${CHANGE_ADVERTISE_STATUS.URL}/${params.id}`, []);
    return newsResponse;
  }

  


}

